import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function CarpetGuideSkeleton() {
    return (
        <div className="guide-content">
            <div className="guide-image">
                <Skeleton height={320} borderRadius={12} />
            </div>

            <div className="guide-info">
                <Skeleton width="60%" height={28} />
                <Skeleton count={2} style={{ marginTop: 10 }} />

                <Skeleton height={180} style={{ marginTop: 20 }} />

                <Skeleton
                    width={160}
                    height={45}
                    style={{ marginTop: 24 }}
                />
            </div>
        </div>
    );
}
